import CustomisableWidgetEditorText from '@intercom/embercom-composer/components/customisable-widget-editor-text';
export default CustomisableWidgetEditorText;
